/** postMessage protocol between embeddable-client.js and /embed/labels iframe. */

export const NM_LABELS_EMBED_SOURCE = "nitromule-labels-embed";
export const NM_LABELS_EMBED_SDK_SOURCE = "nitromule-labels-embed-sdk";

export const LABELS_EMBED_EVENTS = Object.freeze({
  APP_READY: "APP_READY",
  CLOSE_BUTTON_CLICKED: "CLOSE_BUTTON_CLICKED",
  ORDER_CREATED: "ORDER_CREATED",
  ORDERS_CREATED: "ORDERS_CREATED",
  ORDERS_CREATED_ERROR: "ORDERS_CREATED_ERROR",
  LABEL_PURCHASED_SUCCESS: "LABEL_PURCHASED_SUCCESS",
  ERROR: "ERROR"
});

export const LABELS_EMBED_HOST_MESSAGES = Object.freeze({
  INIT: "INIT",
  LABEL_PURCHASE: "LABEL_PURCHASE",
  CLOSE: "CLOSE",
  SET_THEME: "SET_THEME",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  SET_LOCALE: "SET_LOCALE"
});

export const LABELS_EMBED_ERROR_CODES = Object.freeze({
  UNAUTHORIZED: "UNAUTHORIZED",
  LABEL_PURCHASE_ERROR: "LABEL_PURCHASE_ERROR",
  COUNTRY_NOT_SUPPORTED: "COUNTRY_NOT_SUPPORTED",
  LOCALE_NOT_SUPPORTED: "LOCALE_NOT_SUPPORTED",
  UNKNOWN: "UNKNOWN"
});

export function isLabelsEmbedMessage(data) {
  return data && typeof data === "object" && data.source === NM_LABELS_EMBED_SOURCE;
}

export function isLabelsEmbedSdkMessage(data) {
  return data && typeof data === "object" && data.source === NM_LABELS_EMBED_SDK_SOURCE;
}
